// src/AuthContext.js
import React, { createContext, useState, useEffect } from 'react';
import { getAccessToken, getUserRole } from './utils/auth';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authTokens, setAuthTokens] = useState(() => getAccessToken());
  const [userRole, setUserRole] = useState(() => getUserRole(authTokens));

  useEffect(() => {
    // Opdaterer brugerens rolle, når authTokens ændres
    setUserRole(getUserRole(authTokens));
  }, [authTokens]);

  const login = (tokens) => {
    localStorage.setItem('access_token', tokens);
    setAuthTokens(tokens);
  };

  const logout = () => {
    localStorage.removeItem('access_token');
    setAuthTokens(null);
    setUserRole(null);
  };

  return (
    <AuthContext.Provider value={{ authTokens, userRole, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};